import '../../pages/MyDocuments/MyDocuments.scss'
import React, { useState, useEffect} from 'react';
import axios from 'axios';
import { handleFilesUI } from '../../tools';
import { Empty, Space } from 'antd';
import { REACT_APP_WORKING_CHATAPI_URL } from '../../Constants';

function DocumentsList (props){
    const {documentsList} = props;
    const chatApiUrl = REACT_APP_WORKING_CHATAPI_URL
    const user = JSON.parse(localStorage.getItem('user'));

    const handleClickFile = (item) => {
        window.open(item.document_url, "_blank")
    }

    const handleDelete = async (doc) => {
        const formData = new FormData();
        formData.append('document_id', doc.document_id);
        const res = await axios.post(`${chatApiUrl}document_delete/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                authorization: `Bearer ${user.accessToken}`,
            }
        })
        // const res = await axios.post(`${apiUrl}document/deleteFileById`, {document_id: doc.document_id})
        setRerender(!rerender);
    }

    const getButton = (item, index)=>{
        const url = handleFilesUI(item)
        const bProps = {
            key : index,
            className : 'mydoc-shelf-files col-lg-3 col-md-4 col-sm-6',
            style : {background: item.selected ? 'rgb(239, 239, 239)' : 'none'},
        }
        const imgPorps = {
            className: 'mydoc-shelf-files-img',
            src: url.uri,
            alt: "",
        }
        if(props.manageMode){
            imgPorps.onClick = () => props.handleClickFile ? props.handleClickFile(item) : handleClickFile(item);
        }else{
            bProps.onClick = () => { props.handleClickFile ? props.handleClickFile(item) : handleClickFile(item) };
        }

        return (
            <button {...bProps}>
                <img {...imgPorps}/>
                <div className='mydoc-shelf-files-title'>{item.document_name}</div>
                <div className='mydoc-shelf-delete-button'>
                    <img style={{ display: props.manageMode ? "block" : "none" }} className='w-100 h-100' src={require('../../assets/images/close.png')} alt="" onClick={() => props.handleDelete ? props.handleDelete(item) : handleDelete(item)} />
                </div>
            </button>
        )
    }


    return (
        <div className='mydoc-shelf container d-flex justify-content-start align-items-center'>
            {documentsList && documentsList.length > 0 ?
                <div className='d-flex container w-100 row'>
                    {
                        documentsList.map((item, index) => {
                            return getButton(item, index);
                            // const url = handleFilesUI(item)
                            // return (
                            //     <button
                            //         key={index}
                            //         className='mydoc-shelf-files col-lg-3 col-md-4 col-sm-6'
                            //         style={{background: item.selected ? 'rgb(239, 239, 239)' : 'none'}}
                            //         onClick={() => { props.handleClickFile ? props.handleClickFile(item) : handleClickFile(item) }}
                            //     >
                            //         <img className='mydoc-shelf-files-img' src={url.uri} alt="" onClick={() => { props.handleClickFile ? props.handleClickFile(item) : handleClickFile(item) }} />
                            //         <div className='mydoc-shelf-files-title'>{item.document_name}</div>
                            //         <div className='mydoc-shelf-delete-button'>
                            //             <img style={{ display: props.manageMode ? "block" : "none" }} className='w-100 h-100' src={require('../../assets/images/close.png')} alt="" onClick={() => props.handleDelete ? props.handleDelete(item) : handleDelete(item)} />
                            //         </div>
                            //     </button>
                            // )
                        })
                    }
                </div>
                :
                <Space direction="vertical" style={{width: '100%'}}>
                    <Empty
                        description={<span>No files available</span>}
                    />
                </Space>
            }
        </div>
    );
}

export default DocumentsList;